module.exports = __webpack_public_path__ + "static/media/RP-A_S_Timeless_Sforza_DKGrey.5e000df2.png";